import { gql } from '@apollo/client';

const CompanyFieldsFragment = gql`
  fragment CompanyFields on Company {
    name
    companyId
    memberId
    companyInvoiceCardId
  }
`;

export default CompanyFieldsFragment;
